import {isMarkActive} from '@tiptap/core';
import {type EditorState} from '@tiptap/pm/state';

const formatMarkNames = ['bold', 'italic', 'strike'];

export function clearFormatStoredMarks(state: EditorState) {
    const activeMarks = formatMarkNames.filter((markName) => isMarkActive(state, markName));

    Object.values(state.schema.marks).forEach((markType) => {
        if (!activeMarks.includes(markType.name)) {
            state.tr.removeStoredMark(markType);
        }
    });
}
